import LOBBY from "./types";

export const setActivePage = (payload) => {
    return {
        type: LOBBY.SET_ACTIVE_PAGE,
        payload
    }
};
export const selectActiveRoomTab = (payload) => {
    return {
        type: LOBBY.SELECT_ACTIVE_ROOM_TAB,
        payload
    }
};

export const setPromoData = (payload) => {
    return {
        type: LOBBY.SET_PROMO_DATA,
        payload
    }
};
export const deleteSinglePromo = (payload) => {
    return {
        type: LOBBY.DELETE_SINGLE_PROMO,
        payload
    }
};
export const addSinglePromo = (payload) => {
    return {
        type: LOBBY.ADD_SINGLE_PROMO,
        payload
    }
};
export const lobbyOpenModal = (payload) => {
    return {
        type: LOBBY.OPEN_MODAL,
        payload
    }
};

export const closeLobbyModal = (payload) => {
    return {
        type: LOBBY.CLOSE_MODAL,
        payload
    }
};

export const setServerMessage = (payload) => {
    return {
        type: LOBBY.SET_SERVER_MESSAGE,
        payload
    }
};

export const setServerBonusMessage = (payload) => {
    return {
        type: LOBBY.SET_SERVER_BONUS_MESSAGE,
        payload
    }
};

export const lobbySetLoader = (payload) => {
    return {
        type: LOBBY.SET_LOADER,
        payload,
    }
};
export const lobbyUnSetLoader = () => {
    return {
        type: LOBBY.UNSET_LOADER,
    }
};
export const setRakeRaceData = (payload) => {
    return {
        type: LOBBY.SET_RAKE_RACE_DATA,
        payload
    }
};
export const updateRakeRaceProgressLeaderBoard = (payload) => {
    return {
        type: LOBBY.UPDATE_RAKE_RACE_PROGRESS_LEADER_BOARD,
        payload
    }
};
export const toggleAudio = () => {
    return {
        type: LOBBY.TOGGLE_AUDIO,
    }
};
export const lobbySetMaintenance = (payload) => {
    return {
        type: LOBBY.SET_MAINTENANCE,
        payload
    }
};